import gql from 'graphql-tag'

export const GET_DRIVER_SCORES = gql`
  query DriverScores($filter: GetDriverScoresFilter) {
    driverScores(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      driverScores {
        data {
          driverId
          driver {
            fullname
            userId
            isActive
          }
          totalAlert
          harshAccel {
            total
            score
          }
          harshBrake {
            total
            score
          }
          sharpturn {
            total
            score
          }
          overspeed {
            total
            score
          }
          exceededParkingTime {
            total
            score
          }
          exceededIdleTime {
            total
            score
          }
          yawn {
            total
            score
          }
          distraction {
            total
            score
          }
          smoking {
            total
            score
          }
          phoneCalling {
            total
            score
          }
          eyeClosed {
            total
            score
          }
          missingFace {
            total
            score
          }
          finalGrade
          totalDriven
          score
          vehicleGroups {
            name
            id
          }
        }
        aggregation {
          averageScore
          averageFinalGrade
          totalDriver
          lowest10Drivers {
            driver {
              fullname
            }
            driverId
            finalGrade
            score
          }
          top10Drivers {
            driver {
              fullname
            }
            driverId
            finalGrade
            score
          }
        }
        pagination {
          page
          show
          total
        }
      }
    }
  }
`

export const GET_DETAIL_DRIVER_SCORES = gql`
  query AlertDetailDriverScores($filter: GetAlertDetailDriverScoresFilter) {
    alertDetailDriverScores(filter: $filter) {
      alertDetailDriverScores {
        data {
          createdOn
          vehicleId
          alertCode
          driverId
          alertFlag
          alertData
          latitude
          longitude
          alertTrigger
          threshold
          formattedAlertData
          cost
          address
          vehicle {
            licensePlate
          }
          driver {
            fullname
          }
          alert {
            alertCode
            descriptionEng
            descriptionIdn
          }
          isRead
        }
        pagination {
          total
          page
          show
          startCursor
          endCursor
        }
      }
      message
      isSuccessful
    }
  }
`

export const GET_DRIVER_SCORE = gql`
  query DriverScore($filter: GetDriverScoreFilter!) {
    driverScore(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      driverScore {
        driver {
          fullname
          userId
          photograph
          phoneNo
          isActive
        }
        lastSync
        driverId
        totalAlert
        harshAccel {
          total
          score
        }
        harshBrake {
          total
          score
        }
        sharpturn {
          total
          score
        }
        overspeed {
          total
          score
        }
        exceededParkingTime {
          total
          score
        }
        exceededIdleTime {
          total
          score
        }
        yawn {
          total
          score
        }
        distraction {
          total
          score
        }
        smoking {
          total
          score
        }
        phoneCalling {
          total
          score
        }
        eyeClosed {
          total
          score
        }
        missingFace {
          total
          score
        }
        finalGrade
        totalDriven
        score
      }
    }
  }
`

export const GET_RAW_ALERTS_WITH_ADDRESS = gql`
  query RawAlerts(
    $filter: GetRawAlertFilter
    $includeMediaStatus: Boolean = false
    $includeMedia: Boolean = false
  ) {
    rawAlerts(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      rawAlerts {
        data {
          alertCode
          rawAlertId
          isResolved
          alert {
            alertCode
            descriptionEng
            descriptionIdn
            fullDescriptionEng
            fullDescriptionIdn
            iconUrl
            enabledInRule
            alertCategories {
              alertCategoryId
            }
          }
          alertRule {
            label
          }
          alertRuleIds
          driver {
            fullname
            userId
            photograph
            phoneNo
          }
          driverId
          createdOn
          alertTrigger
          alertFlag
          alertData
          shouldHaveMedia
          mediaStatus @include(if: $includeMediaStatus)
          media @include(if: $includeMedia) {
            downloadId
            status
            mediaFilename
          }
          vehicle {
            id
            licensePlate
            imei
            fuelCapacity
            device {
              phoneNo
              deviceCode
            }
            vehicleType {
              category
              icon
            }
            sensor {
              sensorCode
              sensorName
              pinCode
            }
            children {
              id
              imei
            }
            vehicle2Vgroup {
              vgroup {
                name
                id
              }
              vgroupId
            }
          }
          geofences {
            geofenceId
            fenceName
          }
          formattedAlertData
          speed
          longitude
          latitude
          additionalData {
            downloadVideoStatus
          }
          isImportant
          isUrgent
          isRead
          lastUserFeedback {
            feedback
            createdOn
            user {
              fullname
            }
          }
          vehicleId
          readOn
          resolvedOn
          resolvedBy
          resolver {
            fullname
          }
          userLogs {
            typeField
            data
            createdOn
            user {
              fullname
            }
            userId
          }
          isFalseAlert
          sourceDeviceCategory
          sourceDeviceType
          sourceDeviceCategory
          childVehicleId
        }
        pagination {
          page
          show
          total
        }
      }
    }
  }
`

export const UPSERT_RAW_ALERTS_ACTION = gql`
  mutation UpsertRawAlertsAction($input: UpsertRawAlertsActionInput!) {
    upsertRawAlertsAction(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      upsertRawAlertsAction {
        rawAlertId
        userId
        actionType
        type
        data
        createdOn
        aggregate {
          updatedAlerts
          updatedAlertStatuses
          insertedAlertLogs
        }
      }
    }
  }
`

export const TOTAL_IMPORTANT_ALERTS = gql`
  query TotalImportantAlerts($filter: GetTotalImportantAlertsFilter) {
    totalImportantAlerts(filter: $filter) {
      totalImportantAlerts {
        alertUrgencyType
        unresolved
      }
      status
      message
      isSuccessful
      errorName
      errorCode
    }
  }
`

export const GET_RAW_ALERTS_IDS = gql`
  query RawAlerts($filter: GetRawAlertFilter) {
    rawAlerts(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      rawAlerts {
        data {
          rawAlertId
        }
        pagination {
          page
          show
        }
      }
    }
  }
`

export const GET_VEHICLE_GROUPS = gql`
  query VgroupsPaginated($filter: GetVgroupsFilterWithPagination) {
    vgroupsPaginated(filter: $filter) {
      errorCode
      errorName
      isSuccessful
      message
      status
      vgroups {
        data {
          id
          name
        }
        pagination {
          page
          show
          actualTotal
          total
        }
      }
    }
  }
`
